// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/login_bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.imageContainer {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  padding: 10em 5em 4em 8em;
}

.login {
  background-color: white;
  border-radius: 10px;
  font-family: Avenir;
  padding: 20px 40px;
  width: 40%;
}
.badge{
  border-radius: 4px;
  background-color: rgb(250, 169, 18);
  font-family: serif;
  font-weight: bold;
  color: black;
  text-align: center;
  position: relative;
  right: 10px;
}`, "",{"version":3,"sources":["webpack://./src/modules/login/login.css"],"names":[],"mappings":"AAAA;EACE,yDAAuD;EACvD,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb","sourcesContent":[".imageContainer {\r\n  background-image: url(../../assets/images/login_bg.png);\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n  padding: 10em 5em 4em 8em;\r\n}\r\n\r\n.login {\r\n  background-color: white;\r\n  border-radius: 10px;\r\n  font-family: Avenir;\r\n  padding: 20px 40px;\r\n  width: 40%;\r\n}\r\n.badge{\r\n  border-radius: 4px;\r\n  background-color: rgb(250, 169, 18);\r\n  font-family: serif;\r\n  font-weight: bold;\r\n  color: black;\r\n  text-align: center;\r\n  position: relative;\r\n  right: 10px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
